<template>
  <div class="container mescroll-touch">
    <div v-show="showNotice">
      <div class="row">
        本直播及课程内容涉及专业医学知识、临床技术及学术讨论,仅面向<span
          class="blue">医疗专业人士</span>(如医师、护士、药师、医技人员等)观看,如您符合请点击同意后继续浏览,如您并非专业人士，请点击退出。<span
          class="blue">点击"同意"即表示</span>您确认自身为医疗专业人士，已阅读并理解以下述条款，承诺遵守相关要求<span class="blue">如不符合身份条件,请您退出观看。</span>
      </div>
      <div class="stitle">保密与合规</div>
      <div class="row1">
        严格遵守医疗伦理及相关法律法规，不得录制、截图或擅自传播相关内容。涉及患者隐私的信息须予以保密。
      </div>
      <div class="stitle">责任声明</div>
      <div class="row1">
        该内容不代表任何机构或个人的诊疗标准，观看者应结合临床实践指南及患者具体情况独立判断。
      </div>
      <div class="btnrow">
        <div>
          <button @click="getUserInfo">同意</button>
        </div>
        <div>
          <button @click="back">不同意</button>
        </div>
      </div>
    </div>
    <div v-if="gocheck == true" class="check1">
      <div class="checkback"></div>
      <div class="checkkuang">
        <div class="checkicon"><img src="../../assets/images/checkicon.png" alt="" class="con"></div>
        <div class="checktitle">提醒</div>
        <div class="checkinner">感谢关注！本内容仅对专业人士开放，请先完成对应的注册!</div>
        <div class="btrowi">
          <!-- <div class="clo" @click="gocheck = false">取消</div> -->
          <div class="jum1" @click="gohfh()">去注册</div>
        </div>
      </div>
    </div>

    <div v-if="gocheck1 == true" class="check1">
      <div class="checkback"></div>
      <div class="checkkuang">
        <div class="checkicon"><img src="../../assets/images/checkicon.png" alt="" class="con"></div>
        <div class="checktitle">提醒</div>
        <div class="checkinner">感谢关注!本内容仅对ACMED会员开放，请您登录后验证身份，谢谢!</div>
        <div class="btrowi">
          <!-- <div class="clo" @click="gocheck1 = false">取消</div> -->
          <div class="jum1" @click="goacmedzc()">去验证</div>
        </div>
      </div>
    </div>

    <div v-if="gocheck2 == true" class="check1">
      <div class="checkback"></div>
      <div class="checkkuang">
        <div class="checkicon"><img src="../../assets/images/checkicon.png" alt="" class="con"></div>
        <div class="checktitle">提醒</div>
        <div class="checkinner">感谢关注!本内容仅对华肤荟认证用户开放，请您登录后验证身份，谢谢！</div>
        <div class="btrowi">
          <!-- <div class="clo" @click="gocheck2 = false">取消</div> -->
          <div class="jum1" @click="goacmedrz()">去验证</div>
        </div>
      </div>
    </div>

    <!-- <div v-if="gocheck3 == true" class="check1">
      <div class="checkback"></div>
      <div class="checkkuang">
        <div class="checkicon"><img src="../../assets/images/checkicon.png" alt="" class="con"></div>
        <div class="checktitle">提醒</div>
        <div class="checkinner">感谢关注!本内容仅对特定用户开放，请您输入手机号验证身份后观看，谢谢!</div>
        <div class="checkinput">
          <el-input v-model="phone" class="cheinpt" placeholder="请输入您的手机号"></el-input>
        </div>
        <div class="btrowi">
          <div class="jum1" @click="upphone()">提交</div>
        </div>
      </div>
    </div> -->

    <div v-if="gocheck3 == true" class="check1">
      <div class="checkback"></div>
      <div class="checkkuang">
        <div class="checkicon"><img src="../../assets/images/checkicon.png" alt="" class="con"></div>
        <div class="checktitle">提醒</div>
        <div class="checkinner" style="text-align: center;">暂无权限，请稍后再试</div>
        <!-- <div class="checkinput">
          <el-input v-model="phone" class="cheinpt" placeholder="请输入您的手机号"></el-input>
        </div> -->
        <!-- <div class="btrowi">
          <div class="jum1" @click="upphone()">提交</div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userInfo: null,
      id: this.$route.query.id,
      type: this.$route.query.type,
      articleId: this.$route.query.articleId,
      showNotice: false,
      gocheck: false,
      gocheck1: false,
      gocheck2: false,
      gocheck3: false,
      phone: "",
    }
  },
  created() {
    // this.getUserInfo();
    this.GetLiveInfo();
    // this.ifshare();
    document.title = "华肤荟";
  },
  methods: {
    getUserInfo() {
      this.$axios.get('/api/api/web/Customer/GetMyInfo').then(res => {
        console.log("个人信息")
        console.log(res.Data)
        this.userInfo = res.Data;
        let uid = this.userInfo ? this.userInfo.BaseInfo.Id : '';
        let nickName = this.userInfo.BaseInfo.RealName;
        if (this.type == 1) {
          location.href = `https://v.e-way.cc/?id=${this.id}&nickName=${encodeURIComponent(nickName)}&uid=${uid}`;
          // window.open(`https://v.e-way.cc/?id=${this.id}&nickName=${encodeURIComponent(nickName)}&uid=${uid}`);
        } else {
          location.href = `https://v.e-way.cc/vod/?id=${this.id}&nickName=${encodeURIComponent(nickName)}&uid=${uid}`;
          // window.open(`https://v.e-way.cc/vod/?id=${this.id}&nickName=${encodeURIComponent(nickName)}&uid=${uid}`);
        }
      })
    },
    ifshare() {
      let that = this
      this.$axios.get('/api/api/web/Content/CheckPermission?articleId=' + this.articleId).then(res => {
        console.log("会议权限")
        console.log(res.Data)
        if (res.Data.CheckPermission == true) {
          if (!this.showNotice) {
            that.getUserInfo()
          } else {
            this.gocheck = false;
            this.gocheck1 = false;
            this.gocheck2 = false;
            this.gocheck3 = false;
          }
          // this.getUserInfo()
        } else {
          if (res.Data.AllowHFHRegUser == true) {
            that.gocheck = true
          } else {
            if (res.Data.AllowACMEDUser == true) {
              that.gocheck1 = true
            } else {
              if (res.Data.AllowHFHIdUser == true) {
                that.gocheck2 = true
              } else {
                this.gocheck3 = true;
                // if (res.Data.AllowWhiteList == true) {
                //   that.gocheck3 = true
                // } else {
                //   that.gocheck3 = true
                // }
              }
            }
          }
        }
      })
    },
    gohfh() {
      const userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
      console.log(userInfo)
      if (userInfo && userInfo.Status < 30) {
        this.$router.push({
          path: 'login'
        });
      }
      else if (userInfo && userInfo.Status < 40) {
        this.$router.push({
          path: 'compinfo'
        });
      }
    },
    goacmedzc() {
      this.$axios.get("/api/api/web/Customer/GetMyInfo").then((res) => {
        if (res.Data.ACMEDIdentity) {
          this.$router.push({
            path: "/newenterin"
          });
        } else {
          this.$router.push({
            path: '/acmedonly'
          });
        }
      });
    },
    goacmedrz() {
      this.$axios.get("/api/api/web/Customer/GetMyInfo").then((res) => {
        if (res.Data.HFHIdentity == '' || res.Data.HFHIdentity == null) {
          this.$router.push({
            path: 'renzhenginfo'
          });
        } else if (res.Data.HFHIdentity != '' && res.Data.HFHIdentity != null && res.Data.HFHIdentity.Status == 0) {
          this.$dialog
            .alert({
              title: "提示",
              message: "认证审核中，请耐心等待",
            })
            .then(() => { });
        }
      });
    },
    // upphone() {
    //   let that = this
    //   this.$axios.post('/api/api/web/collection/CheckWhiteList', {
    //     CollectionId: this.articleId,
    //     Mobile: this.phone,
    //   }).then(res => {
    //     if (res.Data == false) {
    //       this.$message({
    //         showClose: true,
    //         message: '暂无权限，请稍后再试',
    //         type: 'error'
    //       });
    //     } else {
    //       this.gocheck = false;
    //       this.gocheck1 = false;
    //       this.gocheck2 = false;
    //       this.gocheck3 = false;
    //       this.$router.push({
    //         path: 'programvod',
    //         query: {
    //           id: that.bmdid,
    //           isbmd: "1"
    //         }
    //       });
    //     }
    //   })
    // },
    back() {
      this.$router.go(-1);
    },
    GetLiveInfo() {
      this.$axios.get('/api/api/web/Content/GetLiveInfo?articleId=' + this.articleId).then(res => {
        if (res.RetCode == "10000") {
          this.showNotice = res.Data.IsShowNotice;
          // if (!this.showNotice) {
          this.ifshare();
          // }
        }
      });
    },
  }
}
</script>

<style lang="scss" scoped>
.container {
  position: relative;
  height: 100%;
  background-color: #f7f8fc;
  padding: 12px;
  box-sizing: border-box;
}

.row {
  margin: auto;
  margin-top: 1rem;
  font-size: .426rem;
  width: 85%;
  text-indent: 0.862rem;
  line-height: .7rem;
}

.row1 {
  margin: auto;
  margin-top: .2rem;
  font-size: .426rem;
  width: 85%;
  text-indent: 0.862rem;
  line-height: .7rem;
}

.blue {
  color: rgb(0, 58, 121);
  font-weight: bold;
}

.stitle {
  margin: 0.2rem auto;
  font-size: .426rem;
  width: 85%;
  line-height: .7rem;
  text-align: left;
  font-weight: bold;
  color: rgb(53, 48, 48);
}

.btnrow {
  width: 90%;
  margin: auto;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  margin-top: 1rem;

  div {
    width: 50%;
    text-align: center;

    button {
      border: 0;
      background-image: linear-gradient(to right, rgb(0, 72, 153), rgb(0, 158, 236));
      color: #fff;
      width: 70%;
      padding: 0.2rem 0;
      border-radius: 50px;
    }
  }
}

.closebtn {
  position: absolute;
  right: 5%;
  top: 3%;
  width: 7%;
}

.check1 {
  position: absolute;
  left: 0;
  width: 100%;
  height: 100%;
  top: 0;
  z-index: 999;

  .checkback {
    background: rgba(0, 0, 0, 0.5);
    width: 100%;
    height: 100%;
  }

  .checkkuang {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 999999;
    background: #fff;
    width: 90%;
    border-radius: 15px;
    box-sizing: border-box;
    padding: 0.5rem;
    padding-top: 1.3rem;

    .checkicon {
      width: 20%;
      padding: 0.2rem;
      background: #fff;
      border-radius: 10rem;
      position: absolute;
      left: 50%;
      transform: translate(-50%, -50%);
      top: 0;

      .con {
        display: block;
        width: 100%;
      }
    }

    .checktitle {
      font-size: 0.5rem;
      font-weight: bold;
      text-align: center;
      margin-bottom: 0.5rem;
    }

    .checkinner {
      margin-bottom: 0.5rem;
    }
  }
}

.btrowi {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.clo {
  width: 47%;
  text-align: center;
  border-radius: 10rem;
  border: 1px solid #ddd;
  padding: 0.2rem 0;
  color: #838383;
}

.jum {
  width: 47%;
  text-align: center;
  border-radius: 10rem;
  border: 1px solid #ddd;
  padding: 0.2rem 0;
  color: #fff;
  background-image: linear-gradient(to right, rgb(75, 185, 248), rgb(39, 101, 236));
}

.jum1 {
  width: 100%;
  text-align: center;
  border-radius: 10rem;
  border: 1px solid #ddd;
  padding: 0.2rem 0;
  color: #fff;
  background-image: linear-gradient(to right, rgb(75, 185, 248), rgb(39, 101, 236));
}

.cheinpt {
  margin-bottom: 0.5rem;
}
</style>